/**
 *
 * @module affiliateTracking
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    string
} = Check.assert;

/**
 *
 * @class AffiliateTracking
 *
 */
export default class AffiliateTracking {

    /**
     *
     * @param {String} [affiliateId=undefined]
     * @param {String} [partnerId=undefined]
     * @param {String} [source=undefined]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(affiliateId, partnerId, source) {

        const errorMessage = {
            ctor: 'AffiliateTracking(affiliateId, partnerId, source)',
            get affiliateId() {
                return `${this.ctor} affiliateId should be a String`;
            },
            get partnerId() {
                return `${this.ctor} partnerId should be a String with length`;
            },
            get source() {
                return `${this.ctor} source should be a String with length`;
            }
        };

        if (Check.assigned(affiliateId)) {
            string(affiliateId, errorMessage.affiliateId, InvalidArgumentException);
        }

        if (Check.assigned(partnerId)) {
            string(partnerId, errorMessage.partnerId, InvalidArgumentException);
        }

        if (Check.assigned(source)) {
            string(source, errorMessage.source, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.affiliateId = affiliateId;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.partnerId = partnerId;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.source = source;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/affiliateTracking.js